import 'select2';


// WEBPACK FOOTER //
// ./scripts/autoload/_autocomplete.js